import { Box } from '@mui/material';
import CheckoutEditPane from '../components/EditPanes/CheckoutEditPane';
import CheckoutLiveView from '../components/LiveViews/CheckoutLiveView';
import PreviewPane from '../components/Layout/PreviewPane';

const CheckoutBuilder = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        flex: 1,
        minHeight: 0,
        height: '100%',
        overflow: { xs: 'auto', md: 'hidden' },
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', md: 400 },
          order: { xs: 1, md: 1 },
          flexShrink: 0,
          backgroundColor: '#fff',
          borderRight: { md: '1px solid #e0e0e0' },
          overflow: 'auto',
          height: { xs: 'auto', md: '100%' },
        }}
      >
        <CheckoutEditPane />
      </Box>
      <PreviewPane
        title="Checkout page preview"
        sx={{
          order: { xs: 2, md: 2 },
          overflow: { xs: 'hidden', md: 'auto' },
        }}
        contentSx={{
          transform: { xs: 'none', md: 'scale(0.80)' },
          transformOrigin: 'top center',
        }}
      >
        <CheckoutLiveView />
      </PreviewPane>
    </Box>
  );
};

export default CheckoutBuilder;
